if (!customElements.get('subscription-widget')) {
    customElements.define(
      'subscription-widget',
      class SubscriptionWidget extends HTMLElement {
        constructor() {
          super();
   
          this.main_product_form = this.closest('.product').querySelector('.product-form form[action*="/cart/add"]') || this.closest('.product').querySelector('.product__page form[action*="/cart/add"]') || this.closest('.product').querySelector('.product form[action*="/cart/add"]') || this.closest('.product').querySelector('form[action*="/cart/add.js"]') || this.closest('.product').querySelector('form[action*="/cart/add"]');
          this.currentVariant = JSON.parse(this.querySelector('#currentVariantData').textContent);
          this.sectionId = this.dataset.sectionId;
   
          this.sellingPlanFormInput;
          if (!this.main_product_form.querySelector('input[name="selling_plan"]')) {
            this.sellingPlanFormInput = document.createElement('input');
            this.sellingPlanFormInput.setAttribute('type', 'hidden');
            this.sellingPlanFormInput.setAttribute('name', 'selling_plan');
            this.main_product_form.appendChild(this.sellingPlanFormInput);
          } else {
            this.sellingPlanFormInput = this.main_product_form.querySelector('input[name="selling_plan"]');
          }
          this.sellingPlanFormInput.setAttribute('value', '');

          const subscriptionOption = this.querySelector('.subscription-widget__option--subscription');
          const subscriptionInput = subscriptionOption?.querySelector('input[name="purchase_type"]');
          
          if (subscriptionInput) {
            subscriptionInput.checked = true;

            const select = this.querySelector('.subscription-widget__option--subscription .deployer-select');
            if (select) {
              this.sellingPlanFormInput.value = select.options[select.selectedIndex].dataset.value;
            }
          }
        }
   
        connectedCallback() {
          // Get variant-selects element
          this.variantSelects = this.closest('.product').querySelector('variant-selects');
          
          // update when purchase type changes
          this.querySelectorAll('input[name="purchase_type"]').forEach((input) => {
            input.addEventListener('change', this.handleSellingPlanInput.bind(this));
            // Add direct click/touch handler on input for mobile
            input.addEventListener('click', this.handleInputClick.bind(this));
            input.addEventListener('touchend', this.handleInputTouch.bind(this));
          });

          // Handle direct click on option wrapper for better mobile support
          this.querySelectorAll('.subscription-widget__option-wrapper').forEach((wrapper) => {
            wrapper.addEventListener('click', this.handleOptionClick.bind(this));
            wrapper.addEventListener('touchend', this.handleOptionTouch.bind(this));
          });
   
          // update when selling plan changes
          if (this.querySelector('.deployer-select')) {
            this.querySelector('.deployer-select').addEventListener('change', this.handleSellingPlanInputChange.bind(this));
          }

          // Set initial state for variant selection styling
          this.updateVariantSelectsSubscriptionState();

          this.applyHideOneTimeOffers();
          requestAnimationFrame(() => this.applyHideOneTimeOffers());
          setTimeout(() => this.applyHideOneTimeOffers(), 200);

          // Listen for clicks on variant labels to switch back to one-time purchase
          this.setupVariantClickListener();

          // Initialize button and sticky prices based on current selection
          this.updateButtonAndStickyPrices();
        }

        applyHideOneTimeOffers() {
          if (this.dataset.hideOffers !== 'true') return;
          const vs = this.variantSelects || this.closest('.product')?.querySelector('variant-selects') || document.querySelector('variant-selects');
          if (!vs) return;
          const labels = vs.querySelectorAll('.variant-option__label');
          if (labels.length < 3) return;
          labels.forEach((label, i) => {
            if (i === 1 || i === 2) label.classList.add('variant-option__label--hidden-in-one-time');
            else label.classList.remove('variant-option__label--hidden-in-one-time');
          });
        }

        handleInputClick(e) {
          const input = e.target;
          if (input && !input.checked) {
            input.checked = true;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }

        handleInputTouch(e) {
          e.preventDefault();
          const input = e.target;
          if (input) {
            input.checked = true;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }

        handleOptionClick(e) {
          // Ignore clicks on select dropdown
          if (e.target.closest('.deployer-select')) return;
          
          const option = e.target.closest('.subscription-widget__option');
          if (!option || option.classList.contains('subscription-widget__option--disabled')) return;

          const input = option.querySelector('input[name="purchase_type"]');
          if (input && !input.checked) {
            input.checked = true;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }

        handleOptionTouch(e) {
          // Ignore touches on select dropdown
          if (e.target.closest('.deployer-select')) return;

          const option = e.target.closest('.subscription-widget__option');
          if (!option || option.classList.contains('subscription-widget__option--disabled')) return;

          const input = option.querySelector('input[name="purchase_type"]');
          if (input) {
            e.preventDefault();
            input.checked = true;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }

        setupVariantClickListener() {
          if (!this.variantSelects) return;

          // Add touch-friendly styles to variant labels
          this.variantSelects.querySelectorAll('.variant-option__label').forEach((label) => {
            label.style.touchAction = 'manipulation';
            label.style.webkitTapHighlightColor = 'transparent';
          });

          // Remove previous listeners if exist
          if (this.variantClickHandler) {
            this.variantSelects.removeEventListener('click', this.variantClickHandler);
            this.variantSelects.removeEventListener('touchstart', this.variantTouchHandler);
          }

          this.variantClickHandler = (e) => {
            this.handleVariantInteraction(e);
          };

          this.variantTouchHandler = (e) => {
            this.handleVariantInteraction(e, true);
          };

          this.variantSelects.addEventListener('click', this.variantClickHandler);
          // Use touchstart instead of touchend for faster response
          this.variantSelects.addEventListener('touchstart', this.variantTouchHandler, { passive: false });
        }

        handleVariantInteraction(e, isTouch = false) {
          const label = e.target.closest('.variant-option__label');
          if (!label) return;

          // Don't switch to one-time if we're syncing variant with selling plan
          if (this.isSyncingVariant) return;

          const isSubscriptionActive = this.variantSelects.classList.contains('subscription-active');
          if (!isSubscriptionActive) return;

          // Get the input for the clicked variant
          const input = label.previousElementSibling;
          const isAlreadySelected = input && input.checked;

          // If clicking on a different variant, let the click propagate first
          // then switch to one-time purchase after a small delay
          if (!isAlreadySelected) {
            // Don't prevent default - let the variant change happen
            // Switch to one-time after the variant change processes
            setTimeout(() => {
              this.switchToOneTimePurchase();
            }, 50);
          } else {
            // Clicking on already selected variant - switch immediately
            this.switchToOneTimePurchase();
          }
        }

        switchToOneTimePurchase() {
          const oneTimeOption = this.querySelector('.subscription-widget__option:not(.subscription-widget__option--subscription)');
          const oneTimeInput = oneTimeOption?.querySelector('input[name="purchase_type"]');
          
          if (oneTimeInput) {
            oneTimeInput.checked = true;
            oneTimeInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
   
        handleVariantChange(variant_id) {
          if (this.dataset.hideOffers === 'true') return;
          this.saveCurrentState();
          this.toggleLoadingMode();
          this.renderSubscriptionWidget(variant_id);
        }

        saveCurrentState() {
          const isSubscriptionSelected = this.querySelector('.subscription-widget__option--subscription.subscription-widget__option--selected') !== null;
          const select = this.querySelector('.subscription-widget__option--subscription .deployer-select');
          const selectedSellingPlanIndex = select ? select.selectedIndex : 0;
          
          this.savedState = {
            isSubscription: isSubscriptionSelected,
            sellingPlanIndex: selectedSellingPlanIndex
          };
        }

        restoreState() {
          if (!this.savedState) return;

          const { isSubscription, sellingPlanIndex } = this.savedState;

          // Always sync selling plan with current variant index
          this.syncSellingPlanWithCurrentVariant();

          if (isSubscription) {
            // Select subscription option
            const subscriptionOption = this.querySelector('.subscription-widget__option--subscription');
            const subscriptionInput = subscriptionOption?.querySelector('input[name="purchase_type"]');
            
            if (subscriptionInput) {
              subscriptionInput.checked = true;
              
              // Update classes
              this.querySelectorAll('.subscription-widget__option').forEach((option) => option.classList.remove('subscription-widget__option--selected'));
              subscriptionOption.classList.add('subscription-widget__option--selected');

              // Update the selling plan form input value
              const select = this.querySelector('.subscription-widget__option--subscription .deployer-select');
              if (select) {
                this.sellingPlanFormInput.value = select.options[select.selectedIndex].dataset.value;
              }

              // Update variant-selects state
              if (this.variantSelects) {
                this.variantSelects.classList.add('subscription-active');
              }
            }
          }

          // Clear saved state
          this.savedState = null;
        }

        syncSellingPlanWithCurrentVariant() {
          const select = this.querySelector('.subscription-widget__option--subscription .deployer-select');
          if (!select) return;

          const selectedVariantIndex = this.getSelectedVariantIndex();
          if (selectedVariantIndex === -1 || !select.options[selectedVariantIndex]) return;

          // Update select to match variant index
          select.selectedIndex = selectedVariantIndex;

          // Update frequency text
          const frequencyIndex = select.options[selectedVariantIndex].dataset.frequencyIndex;
          const frequencyItems = this.querySelectorAll('.subscription-widget__frequency-item');
          frequencyItems.forEach((item) => {
            if (item.dataset.frequencyIndex === frequencyIndex) {
              item.classList.add('subscription-widget__frequency-item--active');
            } else {
              item.classList.remove('subscription-widget__frequency-item--active');
            }
          });

          // Update displayed subscription price
          this.updateSubscribePrices({ target: select });
        }

        getSelectedVariantIndex() {
          if (!this.variantSelects) return -1;
          
          const variantInputs = this.variantSelects.querySelectorAll('.variant-option__label');
          let selectedIndex = -1;
          
          variantInputs.forEach((label, index) => {
            const input = label.previousElementSibling;
            if (input && input.checked) {
              selectedIndex = index;
            }
          });
          
          return selectedIndex;
        }
   
        async renderSubscriptionWidget(variant_id) {
          const productUrl = this.dataset.url;
          const requestedVariantId = variant_id;
          const sectionId = this.dataset.sectionId;
          fetch(`${productUrl}?variant=${requestedVariantId}&section_id=${sectionId}`)
            .then((response) => response.text())
            .then((responseText) => {
              const responseHtml = new DOMParser().parseFromString(responseText, 'text/html');
              const source = responseHtml.getElementById(`subscription-widget__${this.dataset.sectionId}`);
              const destination = this;
              if (source && destination) destination.innerHTML = source.innerHTML;
              destination.connectedCallback();
              this.currentVariant = JSON.parse(this.querySelector('#currentVariantData').textContent);
              
              // Restore state after re-render
              this.restoreState();
              
              // Update prices with restored state
              this.updateButtonAndStickyPrices();
              
              this.toggleLoadingMode();
            })
            .catch((error) => {
              console.error("Erreur en tentant de rafraichir le widget d'abonnement:", error);
              this.toggleLoadingMode();
            });
        }
   
        handleSellingPlanInputChange(e) {
          this.updateSubscribePrices(e);
          this.updateFrequencyText(e);
          this.handleSellingPlanInput(e);
          // Also update button and sticky prices when frequency changes
          this.updateButtonAndStickyPrices();
          // Sync variant with selling plan index
          this.syncVariantWithSellingPlan(e);
        }

        syncVariantWithSellingPlan(e) {
          if (this.dataset.hideOffers === 'true') {
            this.setFormVariantFromSubscriptionSelect();
            return;
          }
          const selectedOption = e.target.options[e.target.selectedIndex];
          const frequencyIndex = parseInt(selectedOption.dataset.frequencyIndex);
          if (isNaN(frequencyIndex)) return;

          const variantLabels = this.variantSelects?.querySelectorAll('.variant-option__label');
          if (!variantLabels || variantLabels.length === 0) return;

          const targetVariantLabel = variantLabels[frequencyIndex];
          if (!targetVariantLabel) return;

          const targetInput = targetVariantLabel.previousElementSibling;
          if (!targetInput || targetInput.checked) return;

          this.isSyncingVariant = true;
          targetVariantLabel.click();
          setTimeout(() => { this.isSyncingVariant = false; }, 100);
        }

        updateFrequencyText(e) {
          const selectedOption = e.target.options[e.target.selectedIndex];
          const frequencyIndex = selectedOption.dataset.frequencyIndex;
          const frequencyItems = this.querySelectorAll('.subscription-widget__frequency-item');
          
          frequencyItems.forEach((item) => {
            if (item.dataset.frequencyIndex === frequencyIndex) {
              item.classList.add('subscription-widget__frequency-item--active');
            } else {
              item.classList.remove('subscription-widget__frequency-item--active');
            }
          });
        }
   
        getVariantPriceForSubscription(selectedOption) {
          if (this.dataset.hideOffers !== 'true') return this.currentVariant.price;
          const el = this.querySelector('#subscription-variant-prices');
          if (!el) return this.currentVariant.price;
          let prices;
          try { prices = JSON.parse(el.textContent); } catch (_) { return this.currentVariant.price; }
          const idx = parseInt(selectedOption?.dataset?.frequencyIndex, 10);
          if (isNaN(idx) || idx < 0 || idx >= prices.length) return this.currentVariant.price;
          return prices[idx];
        }

        setFormVariantFromSubscriptionSelect() {
          if (this.dataset.hideOffers !== 'true' || !this.main_product_form) return;
          const idsEl = this.querySelector('#subscription-variant-ids');
          if (!idsEl) return;
          let variantIds;
          try { variantIds = JSON.parse(idsEl.textContent); } catch (_) { return; }
          const select = this.querySelector('.subscription-widget__option--subscription .deployer-select');
          if (!select || select.options.length === 0) return;
          const opt = select.options[select.selectedIndex];
          const idx = parseInt(opt?.dataset?.frequencyIndex, 10);
          if (isNaN(idx) || idx < 0 || idx >= variantIds.length) return;
          const variantInput = this.main_product_form.querySelector('input[name="id"]');
          if (!variantInput) return;
          const newId = variantIds[idx];
          if (String(variantInput.value) === String(newId)) return;
          variantInput.value = newId;
          variantInput.dispatchEvent(new Event('change', { bubbles: true }));
        }

        setFormVariantToOneTimeSelection() {
          if (this.dataset.hideOffers !== 'true' || !this.main_product_form) return;
          const idsEl = this.querySelector('#subscription-variant-ids');
          if (!idsEl) return;
          let variantIds;
          try { variantIds = JSON.parse(idsEl.textContent); } catch (_) { return; }
          let index = this.getSelectedVariantIndex();
          if (index === -1 || index >= variantIds.length) index = 0;
          const variantInput = this.main_product_form.querySelector('input[name="id"]');
          if (!variantInput) return;
          const newId = variantIds[index];
          if (String(variantInput.value) === String(newId)) return;
          variantInput.value = newId;
          variantInput.dispatchEvent(new Event('change', { bubbles: true }));
        }

        syncVariantToSubscriptionSelect() {
          if (this.dataset.hideOffers === 'true') {
            this.setFormVariantFromSubscriptionSelect();
            return;
          }
          if (!this.variantSelects) return;
          const select = this.querySelector('.subscription-widget__option--subscription .deployer-select');
          if (!select || select.options.length === 0) return;
          const opt = select.options[select.selectedIndex];
          const wantIndex = opt ? parseInt(opt.dataset.frequencyIndex, 10) : 1;
          if (isNaN(wantIndex)) return;
          const labels = this.variantSelects.querySelectorAll('.variant-option__label');
          if (labels[wantIndex]) {
            this.isSyncingVariant = true;
            labels[wantIndex].click();
            setTimeout(() => { this.isSyncingVariant = false; }, 150);
          }
        }

        updateSubscribePrices(e) {
          const priceContainer = this.querySelector('.subscription-widget__option--subscription .subscription-widget__option-price-value');
          const selectedOption = e.target.options[e.target.selectedIndex];
          const adjustementType = selectedOption.dataset.ajustmentType;
          const adjustementValue = parseFloat(selectedOption.dataset.ajustmentValue);
          const basePrice = this.getVariantPriceForSubscription(selectedOption);
   
          let adjustedPrice;
   
          switch (adjustementType) {
            case 'fixed_amount':
              adjustedPrice = basePrice - adjustementValue;
              break;
            case 'percentage':
              adjustedPrice = basePrice * (1 - adjustementValue / 100);
              break;
            case 'price':
              adjustedPrice = adjustementValue;
              break;
            default:
              adjustedPrice = basePrice;
              break;
          }
   
          priceContainer.innerText = formatPrice(adjustedPrice);
          this.updateSubscribeSavingPercentage(adjustedPrice, basePrice);
        }
   
        updateSubscribeSavingPercentage(finalPrice, basePriceCents) {
          const savingPercentageContainers = this.querySelectorAll('.subscription-widget__dynamic-discount');
          const variantPrice = (basePriceCents != null ? basePriceCents : this.currentVariant.price) / 100;
          var finalPrice = finalPrice / 100;
          if (!savingPercentageContainers || variantPrice === finalPrice) return;
          savingPercentageContainers.forEach((container) => {
            const saving = ((variantPrice - finalPrice) / variantPrice) * 100;
            container.innerText = Math.round(saving) + '%';
          });
        }
   
        handleSellingPlanInput(e) {
          const selectedOption = e.target.closest('.subscription-widget__option');
          if (selectedOption) {
            const selectedInput = selectedOption.querySelector('input[name="purchase_type"]');
            if (selectedInput) {
              selectedInput.checked = true;
              this.querySelectorAll('input[name="purchase_type"]').forEach((inp) => {
                inp.checked = (inp === selectedInput);
              });
            }
            this.querySelectorAll('.subscription-widget__option').forEach((option) => option.classList.remove('subscription-widget__option--selected'));
            selectedOption.classList.add('subscription-widget__option--selected');
          }
   
          if (selectedOption && selectedOption.classList.contains('subscription-widget__option--subscription')) {
            this.updateVariantSelectsSubscriptionState();
            const select = selectedOption.querySelector('.deployer-select');
            
            const isRadioClick = e.target.tagName === 'INPUT' && e.target.type === 'radio';
            if (isRadioClick && select) {
              if (this.dataset.hideOffers === 'true') {
                select.selectedIndex = 0;
              } else {
                const selectedVariantIndex = this.getSelectedVariantIndex();
                if (selectedVariantIndex !== -1 && select.options[selectedVariantIndex]) {
                  select.selectedIndex = selectedVariantIndex;
                }
              }
              const opt = select.options[select.selectedIndex];
              const frequencyIndex = opt?.dataset?.frequencyIndex;
              const frequencyItems = this.querySelectorAll('.subscription-widget__frequency-item');
              frequencyItems.forEach((item) => {
                item.classList.toggle('subscription-widget__frequency-item--active', item.dataset.frequencyIndex === frequencyIndex);
              });
              this.syncVariantToSubscriptionSelect();
              this.updateSubscribePrices({ target: select });
            }
            
            this.sellingPlanFormInput.value = select?.options[select.selectedIndex]?.dataset?.value || '';
          } else {
            const subscriptionOption = this.querySelector('.subscription-widget__option--subscription');
            if (subscriptionOption) {
              const subInput = subscriptionOption.querySelector('input[name="purchase_type"]');
              if (subInput) subInput.checked = false;
              subscriptionOption.classList.remove('subscription-widget__option--selected');
            }
            this.sellingPlanFormInput.value = '';
            this.setFormVariantToOneTimeSelection();
          }

          this.updateVariantSelectsSubscriptionState();

          this.updateButtonAndStickyPrices();
        }

        updateVariantSelectsSubscriptionState() {
          if (!this.variantSelects) return;
          
          const isSubscriptionSelected = this.querySelector('.subscription-widget__option--subscription.subscription-widget__option--selected') !== null;
          
          if (isSubscriptionSelected) {
            this.variantSelects.classList.add('subscription-active');
          } else {
            this.variantSelects.classList.remove('subscription-active');
          }
        }

        getSubscriptionPrice() {
          const select = this.querySelector('.subscription-widget__option--subscription .deployer-select');
          if (!select) return this.currentVariant.price;

          const selectedOption = select.options[select.selectedIndex];
          const basePrice = this.getVariantPriceForSubscription(selectedOption);
          const adjustmentType = selectedOption?.dataset.ajustmentType;
          const adjustmentValue = parseFloat(selectedOption?.dataset.ajustmentValue) || 0;

          let adjustedPrice;

          switch (adjustmentType) {
            case 'fixed_amount':
              adjustedPrice = basePrice - adjustmentValue;
              break;
            case 'percentage':
              adjustedPrice = basePrice * (1 - adjustmentValue / 100);
              break;
            case 'price':
              adjustedPrice = adjustmentValue;
              break;
            default:
              adjustedPrice = basePrice;
              break;
          }

          return adjustedPrice;
        }

        updateButtonAndStickyPrices() {
          const isSubscriptionSelected = this.querySelector('.subscription-widget__option--subscription.subscription-widget__option--selected') !== null;
          
          // Get price to display
          const priceToDisplay = isSubscriptionSelected ? this.getSubscriptionPrice() : this.currentVariant.price;
          const compareAtPrice = this.currentVariant.compare_at_price;

          // Update add to cart button price
          const addToCartButton = this.main_product_form?.querySelector('button[name="add"]');
          if (addToCartButton) {
            const priceContainer = addToCartButton.querySelector('.product__price .price');
            if (priceContainer) {
              this.updatePriceElement(priceContainer, priceToDisplay, compareAtPrice, isSubscriptionSelected);
            }
          }

          // Update sticky button price if exists
          const stickyButton = this.closest('.product').querySelector('sticky-atc-button');
          if (stickyButton) {
            const stickyPriceContainer = stickyButton.querySelector('.sticky-atc-button__price .price');
            if (stickyPriceContainer) {
              this.updatePriceElement(stickyPriceContainer, priceToDisplay, compareAtPrice, isSubscriptionSelected);
            }
          }
        }

        updatePriceElement(priceContainer, price, compareAtPrice, isSubscription) {
          const regularPriceItem = priceContainer.querySelector('.price__regular .price-item--regular');
          const salePriceItem = priceContainer.querySelector('.price__sale .price-item--sale');
          const saleRegularPriceItem = priceContainer.querySelector('.price__sale .price-item--regular');

          // Format the new price
          const formattedPrice = formatPrice(price);

          // Update regular price
          if (regularPriceItem) {
            regularPriceItem.textContent = formattedPrice;
            regularPriceItem.dataset.price = price;
          }

          // Update sale price
          if (salePriceItem) {
            salePriceItem.textContent = formattedPrice;
            salePriceItem.dataset.price = price;
          }

          // Handle compare at price / on-sale state
          if (isSubscription) {
            // For subscription: use compare_at_price if exists, otherwise use original price
            const crossedOutPrice = compareAtPrice && compareAtPrice > price ? compareAtPrice : this.currentVariant.price;
            priceContainer.classList.add('price--on-sale');
            if (saleRegularPriceItem) {
              saleRegularPriceItem.textContent = formatPrice(crossedOutPrice);
              saleRegularPriceItem.dataset.price = crossedOutPrice;
            }
          } else {
            // For one-time: restore original compare at price behavior
            if (compareAtPrice && compareAtPrice > price) {
              priceContainer.classList.add('price--on-sale');
              if (saleRegularPriceItem) {
                saleRegularPriceItem.textContent = formatPrice(compareAtPrice);
                saleRegularPriceItem.dataset.price = compareAtPrice;
              }
            } else {
              priceContainer.classList.remove('price--on-sale');
            }
          }
        }
   
        toggleLoadingMode() {
          this.classList.toggle('subscription-widget--loading');
        }
      }
    );
  }